import { Location } from 'vue-router'
import { NotificationBanner } from '@/typings/api/NotificationBanner'

import { dateFormatter } from '@/helpers/dateFormatter'
import { NotificationBannerModel as Model } from './Model'
import { createEdit, createView, DELETE } from '@/helpers/enums/table-actions'
import { NOTIFICATION_BANNERS_ROUTES as ROUTES } from './utils'


const getEditRoute = (data: NotificationBanner): Location => ({
  name: ROUTES.EDIT,
  params: { id: data.id.toString() },
})

const getViewRoute = (data: NotificationBanner): Location => ({
  name: ROUTES.VIEW,
  params: { id: data.id.toString() },
})

export const TABLE_ACTIONS = Object.freeze([
  createEdit<NotificationBanner>(getEditRoute),
  createView<NotificationBanner>(getViewRoute),
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Тело',
    value: 'body',
    sortable: true,
    field: (data: NotificationBanner['body']) => {
      const text = data?.replace(/<[^>]*>/g, '')
      return text.length > 110 ? `${text.slice(0, 100)}...` : text
    },
  },
  {
    text: 'Активен?',
    value: 'is_active',
    sortable: false,
    width: 130,
    field: (_: unknown, value: NotificationBanner) => Model.getActiveLabel(value),
  },
  {
    text: 'Начало показа',
    value: 'start_show_at',
    sortable: false,
    width: 144,
    field: (value: NotificationBanner['start_show_at']) => (
      value && dateFormatter(value)
    ),
  },
  {
    text: 'Окончание показа',
    value: 'end_show_at',
    sortable: false,
    width: 144,
    field: (value: NotificationBanner['end_show_at']) => (
      value && dateFormatter(value)
    ),
  },
])
